import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import { Route, Routes, useSearchParams, useNavigate, useLocation } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import TableList from "./components/tableMaster/TableList";
import SingleTableUpdateStructure from "./components/tableMaster/SingleTableUpdateStructure";
import "react-toastify/dist/ReactToastify.css";
import { Project } from "./config/ProjectConfiguration";

import {
    TABLE_LIST,
    UPDATE_TABLE_STRUCTURE,
    REQUEST_LIST,
    VIEW_TABLE_DATA,
    UPDATE_REQUEST_STRUCTURE,
    VIEW_SINGLE_PARAMETER_VALIDATION_LIST,
    COMMAND_LIST,
    CLIENT_LIST,
    USER_GROUP,
    ROLE_MASTER,
    PERMISSION_MASTER,
    MODULE_MASTER,
    USER_MASTER,
    CLIENT_ADD_UPDATE,
    USER_PROFILE,
    DYNAMIC_REQUEST_VIEW,
    DASHBOARD,
    DASHBOARD_DETAIL,
    ROOT,
    DASHBOARD_ITEM_DETAIL,
    CDP_DASHBOARD,
    CDP_PROFILES,
    CDP_EVENTS,
    CDP_SEGMENTS,
    CDP_RULES,
    CDP_CONTEXT,
    CDP_PRIVACY,
    CDP_CAMPAIGNS,
    CDP_PROFILE_DETAIL,
    CDP_SCORING,
    CDP_GOALS,
    CDP_SETTINGS,
    CDP_REPORTS,
    CDP_MONITOR,
    WORKFLOW_LIST,
    WORKFLOW_CREATE
} from "./components/constants/NavigationConstants";
import Sidebar from "./components/common/Sidebar";
import HeaderBar from "./components/common/HeaderBar";
import RequestList from "./components/requestMaster/RequestList";
import SingleRequestUpdateStructure from "./components/requestMaster/SingleRequestUpdateStructure";
import SingleParameterValidation from "./components/parameterValidationMaster/SingleParameterValidation";
import CommandList from "./components/commandMaster/CommandList";
import ClientMaster from "./components/clientMaster/ClientMaster";
import TableRecordsMaster from "./components/tableMaster/tableRecords/TableRecordsMaster";
import UserGroup from "./components/user&Group/UserGroup";
import UserMaster from "./components/users/UserMaster";
import RoleMaster from "./components/roles/RoleMaster";
import PermissionMaster from "./components/permissions/PermissionMaster";
import ModuleMaster from "./components/module/ModuleMaster";


import Constants from "./Constants";
import TrackToken from "./TrackToken";
import "./loader.scss";
import ClientAddUpdate from "./components/clientMaster/ClientAddUpdate";
import UserProfile from "./components/users/UserProfile";
import DynamicRequestForm from "./components/requestMaster/DynamicRequestForm ";
import DashboardMaster from "./components/dashboards/DashboardMaster";
import DashboardDeatil from "./components/dashboards/DashboardDetail";
import DashboardView from "./components/dashboards/DashboardView";
import DashboardItemDetail from "./components/dashboards/DashboardItemDetail";
import Dashboard from "./components/cdp/Dashboard";
import Profiles from "./components/cdp/Profiles";
import Events from "./components/cdp/Events";
import Segments from "./components/cdp/Segments";
import Campaigns from "./components/cdp/Campaigns";
import ContextViewer from "./components/cdp/ContextViewer";
import Privacy from "./components/cdp/Privacy";
import ProfileDetail from "./components/cdp/ProfileDetail";
import Rules from "./components/cdp/Rules";
import ScoringPlans from './components/cdp/ScoringPlans';
import Goals from './components/cdp/Goals';
import Settings from './components/cdp/Settings';
import Reports from './components/cdp/Reports';
import SystemMonitor from './components/cdp/SystemMonitor';
import CDPNavigation from './components/cdp/CDPNavigation';
import WorkflowList from "./components/workflow/WorkflowList";
import WorkflowBuilder from "./components/workflow/CreateWorkflow";



const { AUTH_URL, REDIRECT_URI, TOKEN_URL } = Constants;

const RouteConfig = () => {
    const childRef = useRef();
    const location = useLocation();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const [isAuthenticated, setIsAuthenticated] = useState(false);

    // const isClientPage = location.pathname === CLIENT_LIST || location.pathname.includes("/client-add-update") || location.pathname === "/client-add-update/add-client";
    const isClientPage = location.pathname === CLIENT_LIST;

    const initiateAuth = (enableNavigate = false) => {
        localStorage.setItem("signal", 0);
        localStorage.setItem("counter", 0);

        const code = searchParams.get("code");
        const refreshToken = localStorage.getItem("refresh_token");

        if (code || refreshToken) {
            const payload = {
                grant_type: code ? "authorization_code" : "refresh_token",
                [code ? "code" : "refresh_token"]: code ? code : refreshToken,
                redirect_uri: REDIRECT_URI,
            };

            axios
                .post(TOKEN_URL, payload, {
                    headers: {
                        Authorization:
                            "Basic YXV0by1jb2RlLWFkbWluOmF1dG8tY29kZS1hZG1pbkAwNjEw",
                        "Content-Type": "application/x-www-form-urlencoded",
                    },
                })
                .then((response) => {
                    localStorage.setItem(
                        "access_token",
                        response?.data?.access_token
                    );
                    localStorage.setItem(
                        "refresh_token",
                        response?.data?.refresh_token
                    );
                    setTimeout(() => {
                        setIsAuthenticated(true);
                        childRef?.current?.reset();
                        // Completely disable navigation after authentication
                        // This should preserve URL parameters
                    }, 500);
                })
                .catch((error) => {
                    localStorage.removeItem("access_token");
                    localStorage.removeItem("refresh_token");
                    window.location = AUTH_URL;
                });
            return;
        }

        window.location = AUTH_URL;
    };

    useEffect(() => {
        initiateAuth(true);
    }, []);

    return (
        <>
            {isAuthenticated && (
                <>
                    <TrackToken ref={childRef} initiateAuth={initiateAuth} />
                    <HeaderBar project={Project} isClientPage={isClientPage} />
                    {
                        !isClientPage && (
                            <Sidebar project={Project} />
                        )
                    }
                    <main id="main" className="main">
                        <Routes>
                            <Route path={ROOT} element={<DashboardView />} />
                            <Route path={TABLE_LIST} element={<TableList />} />
                            <Route path={UPDATE_TABLE_STRUCTURE} element={<SingleTableUpdateStructure />} />
                            <Route path={VIEW_TABLE_DATA} element={<TableRecordsMaster />} />
                            <Route path={REQUEST_LIST} element={<RequestList />} />
                            <Route path={UPDATE_REQUEST_STRUCTURE} element={<SingleRequestUpdateStructure />} />
                            <Route path={DYNAMIC_REQUEST_VIEW} element={<DynamicRequestForm />} />
                            <Route path={VIEW_SINGLE_PARAMETER_VALIDATION_LIST} element={<SingleParameterValidation />} />
                            <Route path={COMMAND_LIST} element={<CommandList />} />
                            <Route path={CLIENT_LIST} element={<ClientMaster />} />
                            <Route path={CLIENT_ADD_UPDATE} element={<ClientAddUpdate />} />
                            <Route path={USER_PROFILE} element={<UserProfile />} />
                            <Route path={USER_GROUP} element={<UserGroup />} />
                            <Route path={USER_MASTER} element={<UserMaster />} />
                            <Route path={ROLE_MASTER} element={<RoleMaster />} />
                            <Route path={PERMISSION_MASTER} element={<PermissionMaster />} />
                            <Route path={MODULE_MASTER} element={<ModuleMaster />} />
                            <Route path={DASHBOARD} element={<DashboardMaster />} />
                            <Route path={DASHBOARD_DETAIL} element={<DashboardDeatil />} />
                            <Route path={DASHBOARD_ITEM_DETAIL} element={<DashboardItemDetail />} />

                            <Route path={CDP_DASHBOARD} element={<Dashboard />} />
                            <Route path={CDP_PROFILES} element={<Profiles />} />
                            <Route path={CDP_PROFILE_DETAIL} element={<ProfileDetail />} />
                            <Route path={CDP_EVENTS} element={<Events />} />
                            <Route path={CDP_SEGMENTS} element={<Segments />} />
                            <Route path={CDP_RULES} element={<Rules />} />
                            <Route path={CDP_CAMPAIGNS} element={<Campaigns />} />
                            <Route path={CDP_SCORING} element={<ScoringPlans />} />
                            <Route path={CDP_GOALS} element={<Goals />} />
                            <Route path={CDP_CONTEXT} element={<ContextViewer />} />
                            <Route path={CDP_PRIVACY} element={<Privacy />} />
                            <Route path={CDP_SETTINGS} element={<Settings />} />
                            <Route path={CDP_REPORTS} element={<Reports />} />
                            <Route path={CDP_MONITOR} element={<SystemMonitor />} />
                            <Route path={WORKFLOW_LIST} element={<WorkflowList />} />
                            <Route path={WORKFLOW_CREATE} element={<WorkflowBuilder />} />
                        </Routes>
                    </main>
                    <ToastContainer />
                </>
            )}
            {!isAuthenticated && <div className="loading">Loading</div>}
        </>
    );
};

export default RouteConfig;